import React from 'react';
import ReactDOM from 'react-dom/client';
import {Provider} from "react-redux";

import App from './App';
import {store} from "./store";
import {LocaleProvider} from './i18n';
import {AuthProvider} from './auth/AuthProvider';

import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <LocaleProvider>
                <AuthProvider>
                    <App/>
                </AuthProvider>
            </LocaleProvider>
        </Provider>
    </React.StrictMode>
);
